import qs from 'qs';
import { get } from 'lodash';
import { URLSearch2Params, isEmpty } from '@/utils';
import { tokenKeys, setAuthParams } from '@/plugins/plugin-sso-login';

const SYSTEM_IMPLANT_TOKEN = '__system';
export const system = {
  name: null,
  username: null,
  country: null,
  lang: null,
  utc: null,
  MISP_SUB_TICKET: null,
};
const formatParams = (searchParams) => {
  const keys = Object.keys(searchParams);
  const systemKeys = [
    SYSTEM_IMPLANT_TOKEN,
    'username',
    'country',
    'lang',
    'utc',
    'MISP_SUB_TICKET',
  ];
  let restParams = {};
  let systemParams = {};
  let localSystemParams = {};
  keys.forEach((key) => {
    if (systemKeys.includes(key)) {
      // 特殊处理 SYSTEM_IMPLANT_TOKEN
      if (key === SYSTEM_IMPLANT_TOKEN) {
        systemParams['name'] = searchParams[key];
        // __system参数在url中保留
        restParams[SYSTEM_IMPLANT_TOKEN] = searchParams[key];
      } else {
        systemParams[key] = searchParams[key];
      }
    } else {
      restParams[key] = searchParams[key];
    }
  });
  // url中存在 __systems 时合并本地存储中的参数
  if (restParams[SYSTEM_IMPLANT_TOKEN]) {
    try {
      localSystemParams = JSON.parse(
        sessionStorage.getItem(`${systemParams.name}${SYSTEM_IMPLANT_TOKEN}`),
      );
      systemParams = Object.assign(localSystemParams, systemParams);
    } catch (e) {
      console.warn(e);
    }
  }
  return { restParams, systemParams };
};
const processAuthParams = () => {
  return tokenKeys.reduce((prev, curr) => {
    if (curr === 'u') {
      prev[curr] = system['username'];
    } else {
      prev[curr] = system['MISP_SUB_TICKET'];
    }
    return prev;
  }, {});
};
const setSystem = (data) => {
  // todo 不严谨
  if (!data || typeof data !== 'object') {
    console.warn('参数异常');
    return;
  }
  const _system = Object.assign(system, data);
  // 将system存储到本地
  sessionStorage.setItem(`${system.name}${SYSTEM_IMPLANT_TOKEN}`, JSON.stringify(_system));
  console.info('system', _system);
  return _system;
};
/**
 * 对比嵌入系统后的状态
 */
export const COMPARE_STATUS = {
  agree: 1,
  compatible: 2,
  disagree: 3,
};
/**
 * 初始化嵌入系统
 * 判断是否是嵌入系统，若是继续下面流程
 * 设置系统参数
 * 设置登录信息
 * @returns 重定向地址
 */
export function initSystemImplant() {
  try {
    const searchParams = URLSearch2Params();
    const keys = Object.keys(searchParams);
    if (keys.includes(SYSTEM_IMPLANT_TOKEN)) {
      const { restParams, systemParams } = formatParams(searchParams);
      console.log(`检查到系统嵌入,嵌入系统为${systemParams.name}`);
      setSystem(systemParams);
      const tokenParams = processAuthParams();
      if (!isEmpty(tokenParams) && tokenParams.ticket) {
        setAuthParams(tokenParams);
      }
      let { hash, pathname } = window.location;
      return `${pathname}${isEmpty(restParams) ? '' : '?' + qs.stringify(restParams)}${hash}`;
    }
  } catch (e) {
    console.error(e);
  }
  return '';
}
export function delURLSystemParams(URL) {
  const searchParams = URLSearch2Params(URL);
  const { restParams } = formatParams(searchParams);
  let { hash, pathname } = window.location;
  return `${pathname}${isEmpty(restParams) ? '' : '?' + qs.stringify(restParams)}${hash}`;
}
export function isSystemImplant() {
  if (system.name) return true;
  return false;
}
export function getSystem() {
  return Object.assign({}, system);
}
export function compareSystemToken(system, gattaran, countryList) {
  const defaultLang = 'en-US';
  const defaultCountry = 'BR';
  const equalCountry = system.country === gattaran.country;
  const equalLang = system.lang === gattaran.locale;
  const currentCountry = countryList.find((item) => {
    return item.value === system.country;
  });
  const supportCountry = !!currentCountry?.value;
  const supportLang = currentCountry?.locale?.some((item) => {
    return item.value === system.lang;
  });
  const timezone = get(currentCountry, 'children[0].value');
  const country = supportCountry ? system.country : defaultCountry;
  const locale = supportLang ? system.lang : defaultLang;
  if (equalCountry && equalLang) {
    return {
      result: COMPARE_STATUS.agree,
      msg: '嵌入系统的国家和语言与Gattaran一致，无需重新设置用户信息',
    };
  } else if (equalCountry && !equalLang && !supportLang && gattaran.locale === defaultLang) {
    return {
      result: COMPARE_STATUS.compatible,
      msg: `嵌入系统的语言(${system.lang})与Gattaran(${gattaran.locale})不一致，且Gattaran不支持该语言，使用默认语言${defaultLang}`,
    };
  } else if (!equalCountry && equalLang && !supportCountry && gattaran.country === defaultCountry) {
    return {
      result: COMPARE_STATUS.compatible,
      msg: `嵌入系统的国家(${system.country})与Gattaran(${gattaran.country})不一致，且Gattaran不支持该国家，使用默认国家${defaultCountry}`,
    };
  } else if (
    !equalCountry &&
    !equalLang &&
    !supportCountry &&
    !supportLang &&
    gattaran.country === defaultCountry &&
    gattaran.locale === defaultLang
  ) {
    return {
      result: COMPARE_STATUS.compatible,
      msg: `嵌入系统的国家(${system.country})语言(${system.lang})均与Gattaran不一致，且Gattaran不支持该国家和语言，使用默认国家${defaultCountry}，使用默认语言${defaultLang}`,
    };
  } else {
    return {
      result: COMPARE_STATUS.disagree,
      info: {
        country,
        timezone,
        locale,
      },
      msg: `嵌入系统的国家或语言与当前系统不一致，需重新设置用户信息。设置信息如下：
      国家:(${country})
      语言:(${locale})
      时区:(${timezone})`,
    };
  }
}
